import gql from 'graphql-tag'
import {
	category as categoryFragment,
	surcharge as surchargeFragment,
	options as optionsFragment
} from './fragments'

export default gql`
mutation createCategory($required: CategoryReqFields!, $fields: CategoryFields, $copyId: ID) {
	cashAssist {
	  createMutation: createCategory(required: $required, fields: $fields, copyId: $copyId) {
			id
			mod_ver
			concepts
			cashRegisterId
			...categorymain
			...categorySurcharge
			...categoryOptions
		}
	}
}
${categoryFragment}
${surchargeFragment}
${optionsFragment}`
